import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LabelBindingModel, LabelModel } from 'src/app/models/api/common';
import { StoreService } from 'src/app/services/infra/store/store.service';

@Component({
  selector: 'app-view-labels-multi-select',
  templateUrl: './view-labels-multi-select.component.html',
  styleUrls: ['./view-labels-multi-select.component.scss'],
})
export class ViewLabelsMultiSelectComponent implements OnInit {
  @Input() public labelBindings: LabelBindingModel[] = [];
  @Input() public canBeRemoved = true;
  @Input() public areMerged = false;
  @Input() public multipleRows = true;
  @Output() public removeLabelEventEmitter: EventEmitter<LabelBindingModel> = new EventEmitter<LabelBindingModel>();

  public labels: LabelModel[] = [];
  public additionalLabelBindings: LabelBindingModel[] = [];

  constructor(private readonly _store: StoreService) {
    this._store.labels$.subscribe((labels: LabelModel[]) => {
      this.labels = labels;
    });
  }

  ngOnInit(): void {
    if (this.areMerged && this.labelBindings.length > 2) {
      const mergedLabels = this.labelBindings.slice(1);
      this.labelBindings = [this.labelBindings[0]];
      this.additionalLabelBindings = mergedLabels;
    }
  }

  public getLabelById(labelId: string): LabelModel {
    const label = this.labels.find((label: LabelModel) => label.id === labelId);
    if (!label) {
      return {
        id: labelId,
        displayName: '#DELETED#',
        color: '#000000',
      } as LabelModel;
    }
    return label;
  }

  public clearSingleOption(labelBinding: LabelBindingModel) {
    this.removeLabelEventEmitter.emit(labelBinding);
  }

  public showMergedValues(): boolean {
    return this.areMerged && this.additionalLabelBindings.length > 0;
  }

  public getMergedLabelsDisplayNames(): string[] {
    return this.additionalLabelBindings
      .filter((lb: LabelBindingModel) => lb?.label?.displayName)
      .map((lb: LabelBindingModel) => lb.label.displayName);
  }
}
